import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'cookie-consent';

type GtagFn = (command: string, action: string, params?: Record<string, string>) => void;

const readChoice = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

const saveChoice = (value: 'granted' | 'denied'): void => {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Storage blocked: the choice just won't persist.
  }
};

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(() => readChoice() === null);

  if (!visible) return null;

  const choose = (value: 'granted' | 'denied'): void => {
    const gtag = (window as unknown as { gtag?: GtagFn }).gtag;
    if (typeof gtag === 'function') {
      gtag('consent', 'update', {
        ad_user_data: value,
        ad_personalization: value,
        ad_storage: value,
        analytics_storage: value,
      });
    }
    saveChoice(value);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 inset-x-0 z-40 p-4 bg-gray-900 text-gray-100 border-t border-gray-700 shadow-lg"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center gap-3 text-sm">
        <p className="flex-1">
          We use cookies for analytics and to measure affiliate clicks. You can accept or reject them; see our{' '}
          <Link to="/privacy" className="underline text-accent">Privacy Policy</Link>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button type="button" onClick={() => choose('denied')} className="btn-ghost px-4 py-2">
            Reject
          </button>
          <button type="button" onClick={() => choose('granted')} className="btn-primary px-4 py-2">
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
